import * as Sentry from '@sentry/react';
import packageInfo from '../../../package.json';
import React from 'react';
import {
  createRoutesFromChildren,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { matchRoutes } from 'react-router';

export const initSentry = () => {
  if (!node_env('init') && process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/9thbuilder\.com/,
        /^https:\/\/www\.9thbuilder\.com/,
      ],
      environment: process.env.NODE_ENV,
      debug: process.env.NODE_ENV !== 'production',
      release: `9th-builder@${packageInfo.version}`,
      normalizeDepth: 10,
      attachStacktrace: true,
    });
    node_env_set('init', true);
  }
};

export const node_env = (name: String) => {
  try {
    return process.env['REACT_APP_' + name];
  } catch (ignore) {}
};

export const node_env_set = (name: String, value: any) => {
  try {
    process.env['REACT_APP_' + name] = value;
  } catch (ignore) {}
};
